// extracted by mini-css-extract-plugin
export var root = "_0tgO";
export var rootCards = "_87GM";
export var rootHeading = "_6WMc";
export var rootLightGray = "QgTf";
export var rootWhite = "IJd3";